var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteinfo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.646 2.92188C8.50056 2.92188 5.94427 5.47816 5.94427 8.62363V11.37C5.94427 11.9497 5.69719 12.8334 5.4026 13.3276L4.30976 15.1426C3.63506 16.264 4.1007 17.5089 5.33608 17.927C9.43184 19.2954 13.8507 19.2954 17.9465 17.927C19.0963 17.5469 19.6 16.188 18.9728 15.1426L17.8799 13.3276C17.5949 12.8334 17.3478 11.9497 17.3478 11.37V8.62363C17.3478 5.48767 14.782 2.92188 11.646 2.92188Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4048 3.19737C13.1102 3.11184 12.8061 3.04532 12.4925 3.00731C11.5802 2.89328 10.7059 2.9598 9.88867 3.19737C10.1643 2.49415 10.8485 2 11.6467 2C12.445 2 13.1292 2.49415 13.4048 3.19737Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4967 18.2695C14.4967 19.8375 13.2138 21.1204 11.6458 21.1204C10.8666 21.1204 10.1443 20.7973 9.63118 20.2842C9.11802 19.771 8.79492 19.0488 8.79492 18.2695",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteinfo2);
export default __webpack_public_path__ + "static/media/muteinfo2.719d490a7d103449340e9557c3db9130.svg";
export { ForwardRef as ReactComponent };